import React from 'react'
import { groupBy } from 'lodash-es'
import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { OrderDetail, OrderStatus, UserPreference } from 'api'
import {
  HeroPanel,
  BannerStatusTile,
  BannerCurrencyTile,
  BannerTilesGroup,
  DetailTilesContainer,
  EnvironmentTitle,
  getOrderCashAmounts
} from 'view/shared/heroPanel'
import { createStagingOrderDetailsSelector } from 'selectors/orderSelectors'
import { stagingOrdersCollectionNameSelector } from 'selectors/collectionSelectors'
import { createUserPreferenceSelector } from 'selectors/userPreferenceSelectors'
import { WindowActions } from 'epics/windowEpic'
import { Translation, Locale } from 'locale'
import * as constants from 'view/styles/constants'

interface StagingOrdersHeroPanelProps {
  orderList: OrderDetail[]
  collectionName: string | null
  userPreference: UserPreference
  onTearout: () => void
}

const mapStateToProps = createStructuredSelector({
  orderList: createStagingOrderDetailsSelector(),
  collectionName: stagingOrdersCollectionNameSelector,
  userPreference: createUserPreferenceSelector()
})

const mapDispatchToProps = {
  onTearout: () => WindowActions.tearoutGrid('/quote/tearout/staging')
}

class StagingOrdersHeroPanelComponent extends React.Component<StagingOrdersHeroPanelProps> {
  render() {
    const { orderList, collectionName, userPreference } = this.props
    const ordersByStatus = groupBy(orderList, orderDetail => orderDetail.order.status)
    const readyOrders = ordersByStatus[OrderStatus.READY] || []
    const incompleteOrders = ordersByStatus[OrderStatus.INCOMPLETE] || []
    const preparedOrders = ordersByStatus[OrderStatus.PREPARED] || []
    const cashAmounts = getOrderCashAmounts(orderList)
    const title = `${Locale.translate(Translation.TC_HERO_STAGING)} - ${collectionName || Locale.translate(Translation.TC_HERO_ALL)}`

    return (
      <HeroPanel onTearout={this.props.onTearout}>
        <DetailTilesContainer>
          <EnvironmentTitle data-test-id={'StagingOrdersHeroPanel-EnvironmentTitle'} maxWidth={cashAmounts.length > 0 ? 370 : undefined}>
            {title}
          </EnvironmentTitle>
          <BannerTilesGroup title={Locale.translate(Translation.TC_HERO_STATUS)}>
            <BannerStatusTile
              title={Locale.translate(Translation.TC_UNPREPARED)}
              label={readyOrders.length}
              statusColor={constants.STATUS_COLOR_UNPREPARED}
            />
            <BannerStatusTile
              title={Locale.translate(Translation.TC_ERROR)}
              label={incompleteOrders.length}
              statusColor={constants.STATUS_COLOR_INVALID}
            />
            <BannerStatusTile
              title={Locale.translate(Translation.TC_READY)}
              label={preparedOrders.length}
              statusColor={constants.STATUS_COLOR_STAGING_READY}
            />
          </BannerTilesGroup>
        </DetailTilesContainer>
        {cashAmounts.length > 0 && (
          <DetailTilesContainer large={true}>
            <BannerTilesGroup title={Locale.translate(Translation.TC_HERO_CASH_AMOUNTS)}>
              {cashAmounts.map(cashAmount => (
                <BannerCurrencyTile key={cashAmount.currency} cashAmount={cashAmount} userPreference={userPreference} />
              ))}
            </BannerTilesGroup>
          </DetailTilesContainer>
        )}
      </HeroPanel>
    )
  }
}

export const StagingOrdersHeroPanel = connect(mapStateToProps, mapDispatchToProps)(StagingOrdersHeroPanelComponent)
